import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/contacts/")({
	beforeLoad: () => {
		throw redirect({
			to: "/dashboard/contacts/contact",
		});
	},
});
